import { ReactElement } from 'react'

import { useResolveImportedInvoiceClient } from '@features/importedInvoices/hooks/useResolveImportedInvoiceClient'
import { ImportedInvoice } from '@features/importedInvoices/types/importedInvoice'
import { useUserOrganization } from '@modules-deprecated/app/organization'
import { useTaxRates } from '@modules-deprecated/app/taxrates'

import { ImportedInvoiceDrawerLoader } from '../ImportedInvoiceDrawerLoader'
import { ImportedInvoiceReviewFormContent } from './elements/ImportedInvoiceReviewFormContent'

interface ImportedInvoiceReviewFormProps {
  invoice: ImportedInvoice
}

export const ImportedInvoiceReviewForm = ({ invoice }: ImportedInvoiceReviewFormProps): ReactElement => {
  const { organization } = useUserOrganization()
  const { isLoading: isTaxRatesLoading, taxRatesIncludingDeactivated } = useTaxRates()
  const {
    clientContact,
    isClientAmbiguous,
    isClientToCreate,
    isLoading: isClientContactLoading,
  } = useResolveImportedInvoiceClient({
    extraction: invoice.extraction,
  })

  // The form reads its defaults once on mount, and the extraction's proposed VAT rates are checked
  // against the organization's before that.
  if (!organization || isClientContactLoading || isTaxRatesLoading) {
    return <ImportedInvoiceDrawerLoader />
  }

  return (
    <ImportedInvoiceReviewFormContent
      baseCurrencyId={organization.baseCurrencyId}
      clientContact={clientContact}
      invoice={invoice}
      isClientAmbiguous={isClientAmbiguous}
      isClientToCreate={isClientToCreate}
      taxRates={taxRatesIncludingDeactivated}
    />
  )
}
